import childKicthenScr from '../assets/KidsKitchen.webp';
import outdoorPlayArea from '../assets/OutdoorPlayArea.webp'
export interface FeatureItem {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly buttonText: string;
  readonly buttonLink: string;
  readonly image: string;
  readonly imageAlt: string;
}

export const featuresData: readonly FeatureItem[] = [
  {
    id: 'healthy-meals',
    title: 'Healthy & Nutritious Meals',
    description: 'We provide freshly prepared meals daily, catering for all dietary needs to keep children energised and healthy.',
    buttonText: 'View Menu',
    buttonLink: '/meals',
    image: childKicthenScr,
    imageAlt: 'Nutritious lunch served at the nursery'
  },
  {
    id: 'outdoor-play-area',
    title: 'Spacious Outdoor Play Area',
    description: 'Our safe outdoor space encourages physical activity and exploration, rain or shine.',
    buttonText: '',
    buttonLink: '#',
    image: outdoorPlayArea,
    imageAlt: 'Outdoor play area'
  }
] as const;
